import { jsx as _jsx } from "react/jsx-runtime";
import { useIntl } from 'react-intl';
import { listItemMsg } from '@/shared/components/FormattedListValue';
import { CrmType } from '@/modules/constants';
import { MultiSelectButtons } from '../MultiSelectButtons';
export var FilterCrmTypeButtons = function (_a) {
    var item = _a.item, setFilter = _a.setFilter, activeFilters = _a.activeFilters, label = _a.label, isAlwaysVisible = _a.isAlwaysVisible, enabled = _a.enabled;
    var formatMessage = useIntl().formatMessage;
    return {
        filterItem: item,
        enabled: enabled,
        filterSelectLabel: !isAlwaysVisible ? label : undefined,
        element: (_jsx(MultiSelectButtons, { options: [
                {
                    id: String(CrmType.Customer),
                    label: formatMessage(listItemMsg('crmType', CrmType.Customer, 'Customer')),
                },
                {
                    id: String(CrmType.Prospect),
                    label: formatMessage(listItemMsg('crmType', CrmType.Prospect, 'Prospect')),
                },
                {
                    id: String(CrmType.OwnCompany),
                    label: formatMessage(listItemMsg('crmType', CrmType.OwnCompany, 'Own company')),
                },
                {
                    id: String(CrmType.Other),
                    label: formatMessage(listItemMsg('crmType', CrmType.Other, 'Other')),
                },
            ], onChange: function (value) {
                var _a;
                var _b;
                return setFilter((_a = {},
                    _a[item] = ((_b = value === null || value === void 0 ? void 0 : value.length) !== null && _b !== void 0 ? _b : 0) > 0 ? value : undefined,
                    _a));
            }, selected: activeFilters[item], fullWith: true })),
    };
};
